import React, { useMemo, useState, useEffect } from "react";
import { Map, YMaps, Placemark, Polyline } from "@pbe/react-yandex-maps";
import { apikey } from "../Map/utils/consts";
import imgTransport from "../../assets/images/busWithlowFloor.svg";
import imgArrow from "../../assets/images/arrow-up-svgrepo-com.svg";
import { resData } from "./mock/routes";

// ---- 1) конвертер в точки полилинии
type RawPoint = { latitude: number; longitude: number; index: number; [k: string]: any };
type PointsDict = Record<string, RawPoint>;

function toYandexPolylinePoints(obj: PointsDict): Array<[number, number]> {
  return Object.values(obj)
    .filter((p) => Number.isFinite(p.latitude) && Number.isFinite(p.longitude))
    .sort((a, b) => (a.index ?? 0) - (b.index ?? 0))
    .map((p) => [p.latitude, p.longitude]);
}

// Пример: подставь сюда свой объект
const pointsObj: PointsDict = resData.points;

const TestingPage = () => {
  const [ymapsApi, setYmapsApi] = useState<any>(null);
  const [mapRef, setMapRef] = useState<any>(null);

  const handleMapLoad = (ymaps: any) => setYmapsApi(ymaps);

  // ---- 2) делаем массив координат для линии
  const polylinePoints = useMemo(() => toYandexPolylinePoints(pointsObj), []);

  // ---- 3) авто-приближение к линии (когда есть mapRef и ymapsApi)
  useEffect(() => {
    if (!mapRef || !ymapsApi) return;
    if (polylinePoints.length < 2) return;

    const bounds = ymapsApi.util.bounds.fromPoints(polylinePoints);
    mapRef.setBounds(bounds, { checkZoomRange: true, zoomMargin: 32 });
  }, [mapRef, ymapsApi, polylinePoints]);

  // ---- твоя иконка
  const angle = 0; // градусы
  const radius = 20; // px от центра

  const angleRad = (angle - 90) * (Math.PI / 180);
  const centerX = 16, centerY = 16;

  const arrowLeft = centerX + radius * Math.cos(angleRad) - 10;
  const arrowTop = centerY + radius * Math.sin(angleRad) - 9.5;

  const contentLayout = ymapsApi?.templateLayoutFactory.createClass(
    `
      <div style="position: relative; width: 32px; height: 32px;">
        <img src="${imgTransport}" style="position: absolute; width: 32px; height: 32px; left: 0; top: 0;" />
        <img 
          src="${imgArrow}" 
          style="
            position: absolute;
            width: 19px;
            height: 19px;
            left: ${arrowLeft}px;
            top: ${arrowTop}px;
            transform: rotate(${angle}deg);
          "
        />
      </div>
    `
  );

  return (
    <YMaps
      query={{
        apikey,
        ns: "use-load-option",
        load: "templateLayoutFactory,util.bounds",
      }}
    >
      <div style={{ height: "100vh" }}>
        <Map
          defaultState={{
            center: polylinePoints[0] ?? [56.838011, 60.597465],
            zoom: 12,
          }}
          width="100%"
          height="100%"
          onLoad={handleMapLoad}
          instanceRef={setMapRef}
        >
          {/* ---- 4) сама линия */}
          {polylinePoints.length > 1 && (
            <Polyline
              geometry={polylinePoints}
              options={{
                strokeWidth: 4,
                // strokeColor: "#00A",
                // strokeOpacity: 0.9,
              }}
            />
          )}

          {/* твой маркер */}
          {ymapsApi && (
            <Placemark
              geometry={polylinePoints[0] ?? [56.838011, 60.597465]}
              options={{ iconLayout: contentLayout }}
            />
          )}
        </Map>
      </div>
    </YMaps>
  );
};

export default TestingPage;